export default __webpack_public_path__ + "static/media/tagsDark.4582831f.svg";